module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/11wx3ho/media/FC-9781528908535.jpg?1684515369773",
      "alt": "This image is the cover for the book A Suitcase Full of Boomerangs"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("A Suitcase Full of Boomerangs\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("A Suitcase Full of Boomerangs is essentially a romp around the Republic of Ireland. Tiny boomerangs are bequeathed to colourful characters encountered throughout the three-week round trip. Narrated in the first person, the protagonist and two of her sisters manage to have a ball as they traverse the width and breadth of Ireland in a big black jeep filled with suitcases full of boomerangs. This book of travel laughs, mishaps and adventures is a light-hearted, feel-good read, intended to whisk the armchair traveller far away to another time and place – the magic that will always be Ireland.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Fil Bufalo\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Fil Bufalo has been writing for a lifetime—on the sand, on slate and in shorthand. An animated storyteller and accomplished raconteur, she has gathered all her thoughts, philosophies and musings on life into a bonfire of words and taken the plunge with a match.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0